var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('span',[_vm._v(" Loading… ")]):(_vm.error)?_c('span',[_vm._v(" Failed to load content. ")]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.htmlRaw)}})])}
var staticRenderFns = []

export { render, staticRenderFns }